import MainMenu from '@/components/foundation/main-menu/MainMenu'
import ImportQuoteFromMap from '@/view/import-quote-from-map/ImportQuoteFromMap'

export const ImportQuoteFromMapRoute = {
  path: '/import-quote-from-map',
  name: 'ImportQuoteFromMapRoute',
  components: {
    default: ImportQuoteFromMap,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'event',
    area: 'event',
    breadcrumb: [
      {
        name: 'Cotação',
        link: '/event'
      },
      {
        name: 'Importa Cotação'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/item-quote/ImportQuoteFromMap.js